/* Bijoux, beauté & senteurs et charms ne se vendent que dans une box à composer (demande d'Ivanedge, 08/10/2026).
   Toute ligne de panier de ces pépites qui ne vient pas de l'app Moon Bundles (propriété __moonbundle)
   est retirée, sur chaque page, après chaque ajout au panier et juste avant le paiement.
   La liste des lignes fautives est calculée côté Shopify (section ivg-cart-guard, tags cat-bijoux / cat-beaute-senteurs / charms). */
(function () {
  var busy = null;
  function orphans() {
    return fetch('/?sections=ivg-cart-guard', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var m = /data-ivg-orphans="([^"]*)"/.exec(j['ivg-cart-guard'] || '');
        return m && m[1] ? m[1].split('|').filter(Boolean) : [];
      })
      .catch(function () { return []; });
  }
  function toast() {
    var t = document.createElement('div');
    t.className = 'ivg-guard-toast';
    t.innerHTML = 'Les bijoux et les produits beauté se choisissent dans une box à composer. <a href="/collections/box#compose">Composer ma box</a>';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 7000);
  }
  function check() {
    if (busy) return busy;
    busy = orphans().then(function (keys) {
      if (!keys.length) return false;
      return keys.reduce(function (p, key) {
        return p.then(function () {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
        });
      }, Promise.resolve()).then(function () {
        try { sessionStorage.setItem('ivg-guard-msg', '1'); } catch (e) {}
        location.reload();
        return true;
      });
    }).finally(function () { busy = null; });
    return busy;
  }
  /* Message après rechargement */
  try { if (sessionStorage.getItem('ivg-guard-msg')) { sessionStorage.removeItem('ivg-guard-msg'); document.addEventListener('DOMContentLoaded', toast); } } catch (e) {}
  /* Après chaque ajout ou modification du panier, quelle que soit la façon (thème, app, script) */
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|update)/.test(url)) p.then(function () { setTimeout(check, 600); }, function () {});
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (/\/cart\/(add|update)/.test(String(url))) this.addEventListener('loadend', function () { setTimeout(check, 600); });
    return origOpen.apply(this, arguments);
  };
  /* Avant le paiement : on vérifie, puis on laisse partir */
  var cleared = false;
  function toCheckout(e) {
    if (cleared) return;
    var el = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    if (!el) return;
    e.preventDefault(); e.stopImmediatePropagation();
    check().then(function (removed) { if (removed) return; cleared = true; location.href = '/checkout'; });
  }
  window.addEventListener('click', toCheckout, true);
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (cleared || !f || !/\/cart|\/checkout/.test(f.getAttribute('action') || '') || !(e.submitter && e.submitter.name === 'checkout')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    check().then(function (removed) { if (removed) return; cleared = true; location.href = '/checkout'; });
  }, true);
  /* Au chargement de chaque page */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
